"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Floors points earned when a customer applies any un-earnable payment method.
 * e.g. points burn, promo, un-earnable credits, etc.
 * @example 7 => 7, 11 => 10, 150 => 100, 1500 => 1500, 14999 => 14900
 */
function adjustLuxLoyaltyPointsEarn(points) {
    if (points <= 10)
        return points;
    if (points <= 100)
        return Math.floor(points / 10) * 10;
    return Math.floor(points / 100) * 100;
}
exports.default = adjustLuxLoyaltyPointsEarn;
